import { useTheme } from '@mui/material';
const useNavbarStyles = () => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    return {
        navbarContainerStyles: {
            p: '13px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            nav: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                overflowX: 'auto'
            },
            '&::after': {
                content: '""',
                width: 'calc(100vw - 48px)',
                position: 'absolute',
                borderRadius: 'calc(100vw - 48px)',
                bottom: 0,
                height: 24,
                flexShirnk: 0,
                opacity: 0.48,
                boxShadow: theme.customShadows.z8
            }
        },
        navItemStyles: (isActive) => ({
            display: 'flex',
            py: 1,
            px: 1.5,
            borderRadius: '8px',
            alignItems: 'center',
            gap: 1,
            height: 38,
            background: isActive
                ? isLightMode
                    ? theme.palette.primary.main
                    : theme.palette.primary.light
                : 'transparent',
            transition: '0.3s all',
            '&:hover': {
                background: isLightMode ? theme.palette.primary.main : theme.palette.primary.light,
                h6: {
                    color: isLightMode ? theme.palette.common.white : theme.palette.grey[900]
                },
                svg: {
                    color: `${isLightMode ? theme.palette.common.white : theme.palette.grey[900]} !important`
                }
            }
        })
    };
};
export default useNavbarStyles;
